import { Fragment } from 'react';
import AddressForeign from 'subscription/components/shared/address-foreign';
import Citizenship from 'subscription/components/shared/citizenship';
import AccordionGenerality from 'subscription/components/shared/generality';
import AccordionGeneralityResearch from 'subscription/components/shared/generality-research';
import CancellationAireAccordion from './accordion-citizenship-loss';
import AccordionDocument from './accordion-documents';

interface SubscriptionBirthProps {
  isCohabitation?: boolean;
  isAire?: boolean;
  withoutFamily?: boolean;
  isLossCitizenship?: boolean;
  isCitizenship?: boolean;
  generalityWithResearch?: boolean;
}

const CancellationAire = ({
  isCohabitation = false,
  isAire = false,
  isCitizenship = false,
  generalityWithResearch = false,
  isLossCitizenship = false,
}: SubscriptionBirthProps): React.ReactElement => {
  return (
    <Fragment>
      {generalityWithResearch ? (
        <AccordionGeneralityResearch isCohabitation={isCohabitation} isAire={isAire} disabled />
      ) : (
        <AccordionGenerality isCohabitation={isCohabitation} isAire={isAire} disabled />
      )}
      <Citizenship isCitizenship={isCitizenship} disabledDate disabledNote />
      <AddressForeign isAire={isAire} disabled />
      <CancellationAireAccordion isLossCitizenship={isLossCitizenship} />
      <AccordionDocument />
    </Fragment>
  );
};

CancellationAire.displayName = 'Cancellation Aire component';

export default CancellationAire;
